import React from 'react';
import { Grid } from '@mui/material';
import { range } from 'lodash';
import { gridColumnsAmountToValueDesktop } from 'common/utils/themeUtils';
import CustomizerGridItem from './CustomizerGridItem';
import { SliderValue } from 'common/modules/customization';

export interface Props {
	gridColumns: SliderValue | undefined;
}
const GridItems = (props: Props) => {
	const { gridColumns } = props;

	return (
		<>
			{range(8).map((_, i) => (
				<Grid key={i} item xs={12} sm={gridColumnsAmountToValueDesktop(gridColumns)}>
					<CustomizerGridItem />
				</Grid>
			))}
		</>
	);
};

export default GridItems;
